/**
 * BatchProcessingState - Processing state display with cancel option
 */

import { Loader2, StopCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/v2/ui';

interface BatchProcessingStateProps {
  canCancel: boolean;
  showCancelConfirm: boolean;
  setShowCancelConfirm: (v: boolean) => void;
  cancelMutation: { mutate: () => void; isPending: boolean };
}

export function BatchProcessingState({
  canCancel,
  showCancelConfirm,
  setShowCancelConfirm,
  cancelMutation,
}: BatchProcessingStateProps) {
  const { t } = useTranslation();
  return (
    <div className="p-6 rounded-lg bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 text-center">
      <Loader2 className="h-8 w-8 text-amber-500 animate-spin mx-auto mb-3" />
      <div className="text-sm font-medium text-amber-900 dark:text-amber-100 mb-1">
        {t('batch.processing')}
      </div>
      <div className="text-sm text-amber-700 dark:text-amber-300 mb-4">
        Die Generierung kann bis zu 24 Stunden dauern. Diese Seite aktualisiert sich automatisch.
      </div>

      {canCancel && !showCancelConfirm && (
        <Button
          variant="outline"
          size="sm"
          iconLeft={<StopCircle className="h-4 w-4" />}
          onClick={() => setShowCancelConfirm(true)}
        >
          Batch abbrechen
        </Button>
      )}

      {showCancelConfirm && (
        <div className="mt-4 p-4 rounded-lg bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800">
          <p className="text-sm text-red-700 dark:text-red-300 mb-3">
            Batch wirklich abbrechen? Reservierte Credits werden freigegeben.
          </p>
          <div className="flex justify-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowCancelConfirm(false)}
              disabled={cancelMutation.isPending}
            >
              {t('common.no')}
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => cancelMutation.mutate()}
              loading={cancelMutation.isPending}
            >
              Ja, abbrechen
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
